var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { type: "button" },
              on: { click: _vm.openAddModal }
            },
            [_vm._v(_vm._s(_vm.$t("btnAdd")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: {
                disabled: _vm.selectedBins.length === 0,
                id: "deleteBtn"
              },
              on: { click: _vm.openDeleteModal }
            },
            [_vm._v(_vm._s(_vm.$t("btnDelete")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-warning",
              attrs: { disabled: _vm.selectedBins.length !== 1, id: "editBtn" },
              on: { click: _vm.openEditModal }
            },
            [_vm._v(_vm._s(_vm.$t("btnEdit")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.selectedBins.length === 0 },
              on: { click: _vm.openPrintModal }
            },
            [_vm._v(_vm._s(_vm.$t("btnPrintQr")))]
          ),
          _vm._v(" "),
          _vm.canUpload
            ? _c(
                "button",
                {
                  staticClass: "btn btn-info",
                  attrs: { type: "button" },
                  on: { click: _vm.openImportModal }
                },
                [
                  _c("i", { staticClass: "fas fa-exchange-alt" }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("InvBtnUpload")) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("switch", "inventory")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("inventory.switch.inventories")))]
          )
        ]
      ),
      _vm._v(" "),
      _c("vue-good-table", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.bins,
          "pagination-options": _vm.paginationConfig,
          "select-options": _vm.selectConfig,
          "search-options": { enabled: true, placeholder: _vm.$t("txtSearch") }
        },
        on: { "on-selected-rows-change": _vm.onSelectionChanged }
      }),
      _vm._v(" "),
      _c("BinEditModal", {
        ref: "editModal",
        on: { saved: _vm.fetchAndClear }
      }),
      _vm._v(" "),
      _c("BinDeleteModal", {
        ref: "deleteModal",
        on: { deleted: _vm.fetchAndClear }
      }),
      _vm._v(" "),
      _c("BinPrintModal", { ref: "printModal" }),
      _vm._v(" "),
      _c("BinImportModal", {
        ref: "importModal",
        on: { imported: _vm.fetchBins }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }